<div class="nb-theme-default">
<nb-card>
    <nb-card-body>
        <nb-stepper [orientation]="orientation" #stepper>
            <nb-step *ngFor="let step of numbers" [label]="step['label']">
                <h4></h4>
                <slot [name]="step.stepName"></slot>
                <br>
                <button nbButton [disabled] = "step.stepID == 1 ? true : false" nbStepperPrevious>{{ step.prevButton.title }}</button>
                <button nbButton [disabled] = "length == step.stepID ? true : false" nbStepperNext>{{ step.nextButton.title }}</button>
            </nb-step>
        </nb-stepper>
    </nb-card-body>
</nb-card>
</div>